import React from 'react';
import { Phone } from 'lucide-react';

const CheckoutHeader = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background border-b border-border">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_27fa83fe-13fc-43b1-921c-bb11a32684e7/artifacts/9w38znq2_Go-Turkey-Transfer-logo.png" 
              alt="GoTurkeyTransfer" 
              className="h-8 sm:h-10 w-auto"
            />
          </a>

          {/* Support Link */}
          <a
            href="tel:+44123456789"
            className="flex items-center gap-2 text-foreground/70 hover:text-foreground text-sm font-medium transition-colors"
          >
            <Phone className="h-4 w-4" />
            <span className="hidden sm:inline">24/7 Support</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default CheckoutHeader;
